module.exports = "<div>\r\n  <label></label>\r\n  <input tabindex=\"0\" />\r\n  <span class=\"cb-caret\"></span>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./~/table-js/lib/features/combo-box/ComboBoxTemplate.html
// module id = 1168
// module chunks = 1